exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc-rental .btn-green:hover {\n  background-color: transparent;\n  color: white;\n  z-index: 1;\n}", ""]);

// exports
